// src/components/Header/styles.ts
import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  padding: 1rem 0.5rem;
  background: var(--primary-color, #f9c0f544);
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
  
  /* Add a slight text shadow to make text more readable on the background */
  a, span {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const LaunchButton = styled("a")`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 24px;
  background-color: var(--primary-color, #f9c0f5);
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  
  svg {
    width: 20px;
    height: 20px;
  }
  
  &:hover {
    color: white;
  }
`;

export const Burger = styled("div")`
  @media only screen and (min-width: 891px) {
    display: none;
  }

  display: block;
  cursor: pointer;
  
  .menu-button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
  }
  
  .menu-button-horizontal-line {
    width: 24px;
    height: 2px;
    background-color: #2e186a;
    margin: 5px 0;
    transition: all 0.3s ease;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #18216d;
  transition: color 0.2s ease-in;
  margin: 0.5rem 2rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: var(--primary-color, #f9c0f5);
    text-underline-position: under;
    text-decoration: var(--primary-color, #f9c0f5) underline;
  }
`;